module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAPRJREFUaIHtmd0JwkAQhEcR7MFSUpD2lIK0lPTgS3wwKpyee7f3M0rmg30LezOEj3AEEKKITcVdM+PsbY0lTFSAjQqwUQE2KsBGBdioABsVYKMCbFSAzSoLjLhf4MPJ5dOO0bEnmz2ASyRAyZyX3V04AJgqhp+WnV0ZAFwLg8/LjqFz9ienhIDWHLunDohJnTJdpLXwSt1VWotcqSnSWqRK3VTa2KGppEidI212ntICwHepc6WlFIhJ7ZGWUgB4l9orLa0A8JK6RFozT/ibJxbW+zvoIbX3g2XmaV2gFDPPKi80P8Uu8TmvyM35+zegAmxUgM0NPOPquOx+ZssAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_download.png
// module id = dsD0
// module chunks = 1